var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Contacts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contacts"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-98",
    fill: "#0265FC",
    x: 0,
    y: 0,
    width: 500,
    height: 500,
    rx: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.33526,239.936416 C187.769796,239.936416 206.269796,248.219148 219.661162,261.610514 C233.052528,275.00188 241.33526,293.50188 241.33526,313.936416 L241.33526,313.936416 L241.33526,378.436416 C241.33526,381.059769 240.271936,383.434769 238.552775,385.153931 C236.833613,386.873092 234.458613,387.936416 231.83526,387.936416 L231.83526,387.936416 L71,387.936416 C68.3766474,387.936416 66.0016474,386.873092 64.2824856,385.153931 C62.5633237,383.434769 61.5,381.059769 61.5,378.436416 L61.5,378.436416 L61.5,313.936416 C61.5,293.50188 69.7827321,275.00188 83.1740982,261.610514 C96.5654643,248.219148 115.065464,239.936416 135.5,239.936416 L135.5,239.936416 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 17
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 17,
    cx: 151.800578,
    cy: 156.378613,
    r: 45.8786127
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 15,
    x: 286.5,
    y: 143.5,
    width: 162,
    height: 40,
    rx: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.003905,
    y1: 230.436416,
    x2: 451.507614,
    y2: 230.436416,
    id: "Path-9",
    stroke: "#FFFFFF",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.003905,
    y1: 269.436416,
    x2: 451.507614,
    y2: 269.436416,
    id: "Path-9-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.003905,
    y1: 308.436416,
    x2: 387.715736,
    y2: 308,
    id: "Path-9-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 14,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContact);
export default __webpack_public_path__ + "static/media/icon-contact.d70454c7e108b9f5e3fd2014d138f5b2.svg";
export { ForwardRef as ReactComponent };